import {GovBaseEvent} from "../../types/event.types";

export enum ThemeList {
	auto = 'auto',
	light = 'light',
	dark = 'dark'
}

export interface ThemeSwitchEvent extends GovBaseEvent {
	ref: HTMLGovThemeSwitchElement;
	state: ThemeList
}

